import React from "react";
import BookingCandidateForm from "../../../../components/personalInfo/BookingCandidateForm";
import ContainerMd from "../../../../components/Layouts/ContainerMd";

export default function BookingCandidatePage() {
  return (
    <ContainerMd>
      <BookingCandidateForm />
    </ContainerMd>
  );
}
